import { useMemo } from "react";
import { type RequestState, useAuthenticatedRequest } from "./request";

export interface DigitalSampleRequest {
  comment: string;
  creationDate: string;
  id: number;
  materialFinish: string;
  requester: string;
  status: string;
}

export function useDigitalSampleRequests(
  eljExperimentId: string,
  shouldLoad: boolean,
): RequestState<Array<DigitalSampleRequest>> {
  const config = useMemo(() => {
    const p = new URLSearchParams();
    p.set("status", "OPEN");
    p.set("eljExperimentId", eljExperimentId);
    p.set("_time", Date.now().toString());
    return { params: p };
  }, [eljExperimentId]);
  const [result, error, isLoading] = useAuthenticatedRequest<{
    items: Array<DigitalSampleRequest>;
  }>(
    "/v0/digital-sample-management/digital-sample-requests",
    config,
    shouldLoad,
  );
  return [result?.items, error, isLoading];
}
